module.exports = __webpack_public_path__ + "img/img_manual3_1.2b206e2a.jpg";